<script setup>
import { cn } from 'dashboard/lib/utils';

const props = defineProps({
  class: { type: String, default: '' },
});
</script>

<template>
  <div class="relative w-full overflow-auto">
    <table :class="cn('w-full caption-bottom text-sm', props.class)">
      <slot />
    </table>
  </div>
</template>
